import React from "react"
import "./App.css"
import ProjectDetailsDialog from "./components/model"
import ProjectCard from "./components/project_card"
import SkillCard from "./components/skills_card"
import { logoImage, myImage } from "./data/images"
import { aboutContent, descriptionContent, projects, skills } from "./data/ui_data"
import resume from "./assets/resume.pdf"

const App = () => {
	const footerRef = React.useRef()
	const [selectedProject, setSelectedProject] = React.useState(null)

	const scrollToFooter = () => {
		window.scrollTo({ top: footerRef.current.offsetTop, behavior: "smooth" })
	}
	const handleOpenProject = (projectId) => {
		const index = projects.findIndex((project) => project.id === projectId)
		setSelectedProject(index)
	}
	const closeProjectDialog = () => {
		setSelectedProject(null)
	}

	return (
		<div className="App">
			<nav>
				<img src={logoImage} alt="logo" />
				<button onClick={scrollToFooter} className="blueButton">
					Say Hello
				</button>
			</nav>
			<div className="introduction">
				<h1>{descriptionContent.title}</h1>
				<p>{descriptionContent.description}</p>
				<img src={myImage} alt="my_image" />
				<button className="blueButton">
					<a href={resume} download="Mostapha_benlagha_resume.pdf">
						Download Resume
					</a>
				</button>
			</div>
			<div className="aboutContent">
				<h2>{aboutContent.title}</h2>
				<p>{aboutContent.description}</p>
			</div>

			<div className="row skills">
				{skills.map((skill, index) => (
					<SkillCard skill={skill} key={index} />
				))}
			</div>

			<div className="projectsContainer">
				<h1>My Work</h1>
				<p style={{ margin: "20px auto 5vh auto" }}>
					Here are a few projects I've worked on recently. Want to see more? Email me.
				</p>
				<div className="row" style={{ marginBottom: "10vh" }}>
					{projects.map((project, index) => (
						<ProjectCard
							project={project}
							key={index}
							openProject={handleOpenProject}
						/>
					))}
				</div>
			</div>

			<div className="row mContainer">
				<div className="col col-12 col-sm-12 col-md-4 col-xl-4">
					<h1>Start a project</h1>
				</div>
				<div className="col col-12 col-sm-12 col-md-4 col-xl-4">
					<p style={{ textAlign: "center" }}>
						Interested in working together? We should queue up a chat. I’ll buy the
						coffee.
					</p>
				</div>
				<div className="col col-12 col-sm-12 col-md-4 col-xl-4">
					<a href="mailto:fm_benlagha@esi.dz">Let's do this</a>
				</div>
			</div>

			<div id="footer" ref={footerRef}>
				<img src={logoImage} alt="img" />
				<p>Living, learning, & leveling up one day at a time.</p>
				<div className="links">
					<a
						href="https://www.linkedin.com/in/mostapha-el-amine-benlagha-a24190174/"
						target="_blank"
						rel="noreferrer"
					>
						<i className="fab fa-linkedin"></i>
					</a>
					<a href="https://www.github.com/mostafaben" target="_blank" rel="noreferrer">
						<i className="fab fa-github"></i>
					</a>
					<a
						href="https://www.facebook.com/mostafabenlagha"
						target="_blank"
						rel="noreferrer"
					>
						<i className="fab fa-facebook-square"></i>
					</a>
				</div>
			</div>
			{selectedProject != null ? (
				<ProjectDetailsDialog
					onClose={closeProjectDialog}
					project={projects[selectedProject]}
				/>
			) : null}
		</div>
	)
}

export default App
